import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthSessionFacade } from './auth-session.facade';
import { ROUTE_PATHS } from '../routing/route-paths';

export const authGuard: CanActivateFn = () => {
  const authFacade = inject(AuthSessionFacade);
  const router = inject(Router);

  if (authFacade.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([ROUTE_PATHS.LOGIN]);
};
